var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 633,
    height: 639,
    viewBox: "0 0 633 639",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_765_10957)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_765_10957)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 77.5,
    x2: 77.5,
    y2: 960,
    stroke: "#98A2B3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.5,
    x2: 157.5,
    y2: 960,
    stroke: "#98A2B3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.5,
    x2: 237.5,
    y2: 960,
    stroke: "#98A2B3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.5,
    x2: 317.5,
    y2: 960,
    stroke: "#98A2B3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.5,
    x2: 397.5,
    y2: 960,
    stroke: "#98A2B3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477.5,
    x2: 477.5,
    y2: 960,
    stroke: "#98A2B3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.5,
    x2: 557.5,
    y2: 960,
    stroke: "#98A2B3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_765_10957)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -163,
    y1: 79.5,
    x2: 797,
    y2: 79.5,
    stroke: "#98A2B3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -163,
    y1: 159.5,
    x2: 797,
    y2: 159.5,
    stroke: "#98A2B3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -163,
    y1: 239.5,
    x2: 797,
    y2: 239.5,
    stroke: "#98A2B3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -163,
    y1: 319.5,
    x2: 797,
    y2: 319.5,
    stroke: "#98A2B3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -163,
    y1: 399.5,
    x2: 797,
    y2: 399.5,
    stroke: "#98A2B3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -163,
    y1: 479.5,
    x2: 797,
    y2: 479.5,
    stroke: "#98A2B3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -163,
    y1: 559.5,
    x2: 797,
    y2: 559.5,
    stroke: "#98A2B3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_765_10957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 633,
    height: 639,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_765_10957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 960,
    fill: "white",
    transform: "translate(-163)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_765_10957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 960,
    fill: "white",
    transform: "translate(-163)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPattern);
export default __webpack_public_path__ + "static/media/bg-pattern.bb5eca22830d610ad6054099636c3fdc.svg";
export { ForwardRef as ReactComponent };